const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.75a.75.75 0 0 0-.306.065l-.19.123-.035.032-7.249 7.249a.751.751 0 1 0 1.062 1.062l5.967-5.967v12.934a.751.751 0 0 0 1.502 0V6.314l5.967 5.967a.751.751 0 0 0 1.062-1.062L12.531 3.97l-.002-.002A.75.75 0 0 0 12 3.75"/></svg>';
export {
  a as w
};
